import { StyleSheet, css } from 'aphrodite';
import { AppTheme } from '../../styles/AppTheme';

export const Styles = StyleSheet.create({
  container: {
    display: 'flex',
    paddingTop: 20,
    flexDirection: 'column',
    alignItems: 'center',
    flex: 1,
  },
  statContainer: {
    width: '95%',
    textAlign: 'center',
    marginTop: 15
  },
  statAdjustContainerTitle: {
    margin: 0,
    marginRight: 10,
  },
  statAdjustContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    minHeight: 30,
    flex: 1,
  },
  statAdjustInfo: {
    display: 'flex',
    alignItems: 'flex-end',
    flex: 1,
    marginTop: 20,
    marginBottom: 20,
  },
  statAdjustVal: {
    margin: 0,
    fontSize: 18,
    fontWeight: 'bold',
    //minWidth: 100,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  statAdjustIcon: {
    height: 18,
    width: 18,
    fontSize: 18,
    minHeight: 18,
    minWidth: 18,
  },
  statAdjustIconContainer: {
    height: 26,
    width: 26,
    fontSize: 26,
    minHeight: 26,
    minWidth: 26,
  },
  outerContainer: {
    paddingBottom: 30,
    width: '95%',
    display: 'flex',
  },
  paginationContainer: {
    width: '95%',
    display: 'flex',
    alignItems: 'center',
    paddingBottom: 10,
    //paddingTop: 10
  },
  paginationContent: {
    display: 'flex',
    justifyContent: 'flex-end',
    flex: 1,
    alignItems: 'center'
  },
  pageNumber: {
    minWidth: 70,
    textAlign: 'center',
    margin: 0,
  },
  formOuterContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: .7,
    marginRight: 10
  },
  formSecondOuterContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: .5,
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: AppTheme.secondaryBg,
    padding: 10
  },
  formInnerContainer: {
    display: 'flex'
  },
  formSelectFirstContainer: {
    flex: 1,
    display: 'flex',
  },
  formDateContainer: {
    display: 'flex',
    backgroundColor: AppTheme.secondaryBg,
    padding: 10,
    marginTop: 10
  },
  actionButtonClose: {
    backgroundColor: 'white',
    color: 'black',
    fontWeight: 'bolder',
    margin: 0,
    fontSize: 16,
    textTransform: 'unset',
  },
  actionButton: {
    backgroundColor: 'white',
    color: 'black',
    fontWeight: 'bolder',
    margin: 0,
    marginRight: 10,
    fontSize: 16,
    textTransform: 'unset',
  },
  headerContainer: {
    fontSize: 20,
    fontWeight: 'bold',
    margin: 0,
    display: 'flex',
    alignItems: 'center'
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    flex: 1,
  },
  selectInnerContainer: {
    flex: .5,
    display: 'flex',
    marginTop: 5
  },
  selectDateInnerContainer: {
    flex: 1,
    display: 'flex',
    marginTop: 5
  },
  eventActionContainer: {
    marginTop: 20,
    display: 'flex'
  },
  eventButton: {
    borderBottom: '2px solid #303E8A',
    flex: .5,
    borderRadius: 0,
    fontWeight: 'bolder',
    cursor: 'pointer'
  },
  liveButton: {
    borderBottom: '2px solid white',
    flex: .5,
    borderRadius: 0,
    fontWeight: 600,
    cursor: 'pointer'
  },
  videoButton: {
    borderBottom: '2px solid #F5F5F5',
    flex: .5,
    borderRadius: 0,
    fontWeight: 600
  },
  eventContainer: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: AppTheme.secondaryBg,
    padding: 10,
  },
  eventContainerHeader: {
    display: 'flex',
    minHeight: 50,
  },
  refreshContainer: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  inputCss: {
    margin: 0,
    marginRight: 10,
    border: '1px solid rgba(0, 0, 0, 0.12)',
    backgroundColor: 'white',
    paddingLeft: 5,
  },
  inputCssROI: {
    margin: '5px 0px 10px 0px',
    flex: 1,
    color: '#757575'
  },
  textFieldContent: {
    ':before': {
      borderBottom: 0,
    },
    ':after': {
      borderBottom: 0,
    },
  },
  animated: {
    paddingLeft: 5
  },
  refreshIcon: {
    borderRadius: '50%',
    color: 'white',
    backgroundColor: '#303E8A',
    padding: 5,
    fontSize: 25,
    cursor: 'pointer',
  },
  divider: {
    marginTop: 10,
    color: 'white',
  },
  eventsDivider: {
    marginBottom: 15
  },
  eventContainerImg: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'black'
    /*width: '100%',
    height: 300,
    marginTop: 10,
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'black',
    position: 'relative',*/
  },
  latestEventContainerImg: {
    width: '100%',
    height: 'auto',
    //marginTop: 10,
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'black',
    position: 'relative',
    alignItems: 'center',
  },
  eventContainerImgLive: {
    /*position: 'absolute',
    zIndex: 1*/
  },
  eventImg: {
    width: '100%',
    zIndex: 1
  },

  dialog: {
    minWidth: 500,
  },
  scrollPaper: {
    justifyContent: 'center',
    '@media(max-width: 767px)': {
      overflow: 'scroll',
      justifyContent: 'flex-start'
    }
  },
  dialogTitle: {
    borderBottom: '2px solid whitesmoke',
    padding: 20,
    backgroundColor: '#303E8A',
  },
  dialogTitleContent: {
    fontWeight: 600,
    fontSize: 25,
    margin: 0,
    color: 'white'
  },
  dialogContent: {
    padding: '0px 20px',
  },
  fieldsContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  fieldsContainerCord: {
    display: 'flex',
    flexDirection: 'column',
  },
  fieldsContainerCoContent: {
    marginBottom: 0,
    fontWeight: 600
  },
  dialogActions: {
    margin: 20,
    display: 'flex',
    justifyContent: 'flex-start'
  },
  textFieldContentInput: {
    color: 'black',
    fontWeight: 600,
    ':before': {
      borderBottom: '2px solid #757575',
    },
    ':after': {
      borderBottom: '2px solid #3F51B5',
    },
  },
  // textFieldContent: {
  //   color: '#757575',
  // },
  focused: {
    color: '#3F51B5',
    fontWeight: 'bold'
  },
  deleteMsg: {
    margin: 20,
    marginTop: 0,
    fontWeight: 'bold',
    color: 'red',
    fontSize: 15
  },
  link: {
    textDecoration: 'none'
  },
  fillSpace: {
    flex: 1
  },
  formControlLabel: {
    fontWeight: 'bolder',
    fontSize: 17
  },
  errMsg: {
    color: 'red',
    marginTop: 0,
    marginLeft: 20,
  },
  marginRight: {
    marginRight: 10,
  },
})


// WEBPACK FOOTER //
// ./src/screens/ClientPlace/Styles.js